export const GET_SITE_SVC = 'GET_SITE_SVC'
export const GET_SUCCESS_SITE_SVC = 'GET_SUCCESS_SITE_SVC'
export const GET_ERROR_SITE_SVC = 'GET_ERROR_SITE_SVC'
export const SITE_GET_ALL = 'SITE_GET_ALL'
export const SITE_GET_ALL_SUCCESS = 'SITE_GET_ALL_SUCCESS'
export const SITE_GET_ALL_LIST = 'SITE_GET_ALL_LIST'
export const SITE_GET_ALL_LIST_SUCCESS = 'SITE_GET_ALL_LIST_SUCCESS'
export const SITE_ADD_PDF = 'SITE_ADD_PDF'
export const GET_SITE_BY_CUSTOMER = 'GET_SITE_BY_CUSTOMER'
